<app-card-content [border]="false" [headerColor]="true" icon="pi pi-id-card" title="Dados de Registro" subtitle="Informações de inscrição do médico">
    <div card-header>
        @if (!acoesDesabilitadas()) {
            <app-botao-acoes label="Ações" [items]="acoesFormulario" [destaque]="itensEdicao" [destaqueAtivo]="modoEdicao()" [appCan]="roleDadosRegistroEditar" [appCanUf]="pessoa()?.uf" [permissaoUf]="pessoa()?.uf ?? null" />
        }
    </div>

    <form [formGroup]="dadosRegistroForm" class="dados-registro-form">
        <div class="dados-registro-corpo">
            <!-- 1. Dados Pessoais -->
            <app-card-content [headerColor]="false" icon="pi pi-user" title="Dados Pessoais" subtitle="Informações pessoais e deficiências">
                <app-dados-pessoais
                    [modoEdicao]="modoEdicao()"
                    [carregandoDominios]="carregandoDominios()"
                    [opcoesGenero]="opcoesGenero"
                    [opcoesEstadoCivil]="opcoesEstadoCivil"
                    [opcoesSimNao]="opcoesSimNao"
                    [mostrarSecaoDeficiencias]="mostrarSecaoDeficiencias()"
                    [comDeficiencia]="dadosRegistroForm.get('comDeficiencia')?.value ?? null"
                    (abrirDialogDeficiencia)="abrirDialogDeficiencia()"
                ></app-dados-pessoais>
            </app-card-content>

            <!-- 2. Dados de Inscrição — Emitir Cert. Ética no card-header -->
            <app-card-content [headerColor]="false" icon="pi pi-id-card" title="Dados de Inscrição" subtitle="Tipo, situação e datas de inscrição">
                <div card-header class="flex items-center gap-2">
                    <label for="emitirCertEtica" class="text-xs font-semibold" style="color: var(--text-color-secondary)">Emitir Cert. Ética</label>
                    <app-switch-sim-nao inputId="emitirCertEtica" formControlName="emitirCertEtica" [desabilitado]="!modoEdicao()" />
                </div>
                <app-dados-inscricao
                    [modoEdicao]="modoEdicao()"
                    [opcoesTipoInscricao]="opcoesTipoInscricao"
                    [opcoesSituacao]="opcoesSituacao()"
                    [carregandoDominios]="carregandoDominios()"
                    [formValid]="formValid()"
                    [acoesDesabilitadas]="acoesDesabilitadas()"
                    (onSaveChanges)="salvarDados()"
                    (onCancelChanges)="cancelarEdicao()"
                    (onEdit)="habilitarEdicao()"
                ></app-dados-inscricao>
            </app-card-content>

            <!-- 3. Suspensão (controlado externamente) -->
            @if (mostrarAreaSuspensao()) {
                <app-card-content [headerColor]="false" icon="pi pi-ban" title="Suspensão" subtitle="Períodos de suspensão de inscrição">
                    <app-suspensao [modoEdicao]="modoEdicao()" [mostrarAreaSuspensao]="mostrarAreaSuspensao()" [suspensoes]="suspensoes()" [loadingSuspensoes]="loadingSuspensoes()" [erroSuspensoes]="erroSuspensoes()"></app-suspensao>
                </app-card-content>
            }

            <!-- 4. Tipo Sanguíneo -->
            <app-card-content [headerColor]="false" icon="pi pi-heart-fill" title="Tipo Sanguíneo" subtitle="Grupo sanguíneo e doação de órgãos">
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div class="field">
                        <label for="tipoSanguineo" class="font-semibold block mb-2">Tipo Sanguíneo</label>
                        <p-select
                            [appendTo]="'body'"
                            id="tipoSanguineo"
                            formControlName="tipoSanguineo"
                            [options]="opcoesTipoSanguineo"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Selecione"
                            [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                            [readonly]="!modoEdicao()"
                        />
                    </div>
                    <div class="field">
                        <label for="rh" class="font-semibold block mb-2">Fator RH</label>
                        <p-select
                            [appendTo]="'body'"
                            id="rh"
                            formControlName="rh"
                            [options]="opcoesRH"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Selecione"
                            [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                            [readonly]="!modoEdicao()"
                        />
                    </div>
                    <div class="field">
                        <label for="doacaoOrgaos" class="font-semibold block mb-2">Doador de Órgãos</label>
                        <p-select
                            [appendTo]="'body'"
                            id="doacaoOrgaos"
                            formControlName="doacaoOrgaos"
                            [options]="opcoesDoacaoOrgaos"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Selecione"
                            [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                            [readonly]="!modoEdicao()"
                        />
                    </div>
                </div>
            </app-card-content>

            <!-- 5. Dados Militares -->
            <app-card-content [headerColor]="false" icon="pi pi-shield" title="Dados Militares" subtitle="Categoria e situação militar">
                <app-dados-militares [modoEdicao]="modoEdicao()" [opcoesCategoriaMilitar]="opcoesCategoriaMilitar"></app-dados-militares>
            </app-card-content>

            <!-- 6. Filiação -->
            <app-card-content [headerColor]="false" icon="pi pi-sitemap" title="Filiação" subtitle="Nome dos pais">
                <app-filiacao [modoEdicao]="modoEdicao()"></app-filiacao>
            </app-card-content>

            <!-- 7. Localização -->
            <app-card-content [headerColor]="false" icon="pi pi-globe" title="Localização" subtitle="Nacionalidade e país de origem">
                <app-localizacao [modoEdicao]="modoEdicao()" [carregandoDominios]="carregandoDominios()" [opcoesNacionalidade]="opcoesNacionalidade" [opcoesPaises]="opcoesPaises" [paisEhBrasil]="paisEhBrasil()"></app-localizacao>
            </app-card-content>

            <!-- 8. Censura Pública — botão Adicionar no card-header -->
            @if (mostrarCensuraPublica()) {
                <app-card-content [headerColor]="false" icon="pi pi-hammer" title="Censura Pública" subtitle="Registros de censura pública">
                    <div card-header>
                        @if (modoEdicao()) {
                            <p-button label="Adicionar" icon="pi pi-plus" size="small" [appCan]="roleCensuraPublicaEditar" [appCanUf]="pessoa()?.uf" [disabled]="salvandoCensuraPublica()" (onClick)="abrirDialogCensuraPublica()" />
                        }
                    </div>
                    <app-censura-publica
                        [modoEdicao]="modoEdicao()"
                        [censuras]="censurasPublicas()"
                        [loadingCensurasPublicas]="loadingCensurasPublicas()"
                        [erroCensurasPublicas]="erroCensurasPublicas()"
                        [salvandoCensuraPublica]="salvandoCensuraPublica()"
                        [roleEditar]="roleCensuraPublicaEditar"
                        [uf]="pessoa()?.uf"
                        (abrirDialog)="abrirDialogCensuraPublica()"
                        (editar)="iniciarEdicaoCensuraPublica($event)"
                        (visualizar)="visualizarAnexoCensuraPublica($event)"
                    ></app-censura-publica>
                </app-card-content>
            }
        </div>
    </form>
</app-card-content>

<!-- Diálogo para capturar a data da alteração do tipo de inscrição -->
<p-dialog appDialogoPadrao="pi pi-users" descricao="Quando a inscrição mudou de tipo." header="Data da alteração da inscrição" [(visible)]="showDataAlteracaoDialog" [closable]="false" [dismissableMask]="false" [style]="{ width: '400px' }">
    <div class="p-fluid">
        <div class="field">
            <label for="dtAltTipoInscricao">Informe a data</label>
            <input id="dtAltTipoInscricao" type="date" [(ngModel)]="dataAlteracaoTemp" [ngModelOptions]="{ standalone: true }" class="p-inputtext p-component" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button type="button" label="Cancelar" styleClass="p-button-text" (onClick)="cancelarDataAlteracao()"></p-button>
        <p-button type="button" label="Confirmar" [disabled]="!dataAlteracaoTemp" (onClick)="confirmarDataAlteracao()" styleClass="p-button-primary"></p-button>
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Quando a situação do registro mudou."
    header="Data da mudança da situação"
    [(visible)]="mostrarDialogMudancaSituacao"
    [closable]="false"
    [dismissableMask]="false"
    [style]="{ width: '420px', maxWidth: '95vw' }"
>
    <div class="p-fluid">
        <div class="field">
            <label for="dtMudancaSituacao" class="font-semibold block mb-2">Data da mudança *</label>
            <p-inputmask id="dtMudancaSituacao" [(ngModel)]="dataMudancaSituacaoTemp" [ngModelOptions]="{ standalone: true }" mask="99/99/9999" placeholder="DD/MM/AAAA" styleClass="w-full" />
            @if (situacaoMudancaDescricao) {
                <small class="text-color-secondary mt-2">Situação selecionada: {{ situacaoMudancaDescricao }}</small>
            }
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button type="button" label="Cancelar" styleClass="p-button-text" (onClick)="cancelarDialogMudancaSituacao()"></p-button>
        <p-button type="button" label="Confirmar" [disabled]="!dataMudancaSituacaoTemp" (onClick)="confirmarDialogMudancaSituacao()" styleClass="p-button-primary"></p-button>
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-info-circle"
    descricao="Deficiência informada no cadastro."
    header="Detalhes da deficiência"
    [(visible)]="mostrarDialogDeficiencia"
    [closable]="false"
    [dismissableMask]="false"
    [style]="{ width: '600px', maxWidth: '95vw' }"
>
    <div class="p-fluid" [formGroup]="dadosRegistroForm">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="field">
                <label for="tipoDeficiencia" class="font-semibold block mb-2">Tipo de deficiência</label>
                <p-select
                    [appendTo]="'body'"
                    #tipoDeficienciaSelect
                    id="tipoDeficiencia"
                    formControlName="tipoDeficiencia"
                    [options]="opcoesTipoDeficiencia"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [readonly]="!modoEdicao()"
                />
            </div>
            <div class="field">
                <label for="origemDeficiencia" class="font-semibold block mb-2">Origem</label>
                <p-select
                    [appendTo]="'body'"
                    #origemDeficienciaSelect
                    id="origemDeficiencia"
                    formControlName="origemDeficiencia"
                    [options]="opcoesOrigemDeficiencia"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [readonly]="!modoEdicao()"
                />
            </div>
            <div class="field">
                <label for="deficienciaAdaptada" class="font-semibold block mb-2">Deficiência adaptada</label>
                <p-select
                    [appendTo]="'body'"
                    #deficienciaAdaptadaSelect
                    id="deficienciaAdaptada"
                    formControlName="deficienciaAdaptada"
                    [options]="opcoesSimNao"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [readonly]="!modoEdicao()"
                />
            </div>
            <div class="field md:col-span-2">
                <label for="deficiencias" class="font-semibold block mb-2">Outras informações</label>
                <textarea
                    #deficienciaOutras
                    id="deficiencias"
                    pInputTextarea
                    rows="3"
                    formControlName="deficiencias"
                    placeholder="Descreva outras informações"
                    [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [readonly]="!modoEdicao()"
                ></textarea>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button type="button" label="Cancelar" styleClass="p-button-text" (onClick)="cancelarDialogDeficiencia()"></p-button>
        <p-button type="button" label="Confirmar" (onClick)="confirmarDialogDeficiencia()" styleClass="p-button-primary"></p-button>
    </ng-template>
</p-dialog>

<p-dialog appDialogoPadrao="pi pi-ban" descricao="Período e motivo da suspensão." header="Suspensão de inscrição" [(visible)]="mostrarDialogSuspensao" [closable]="false" [dismissableMask]="false" [style]="{ width: '520px', maxWidth: '95vw' }">
    <div class="p-fluid" [formGroup]="dadosRegistroForm">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="field">
                <label for="suspensaoInicioDialog" class="font-semibold block mb-2">Data de início *</label>
                <p-datepicker
                    #suspensaoInicioInput
                    id="suspensaoInicioDialog"
                    formControlName="suspensaoInicio"
                    dateFormat="dd/mm/yy"
                    dataType="string"
                    placeholder="DD/MM/AAAA"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    [appendTo]="'body'"
                    [styleClass]="classeDatePickerSuspensao('suspensaoInicio')"
                    [readonlyInput]="!modoEdicao()"
                />
                @if (campoSuspensaoInvalido('suspensaoInicio')) {
                    <small class="erro-campo">{{ mensagemErroSuspensao('suspensaoInicio') }}</small>
                }
            </div>
            <div class="field">
                <label for="suspensaoFimDialog" class="font-semibold block mb-2">Data fim</label>
                <p-datepicker
                    #suspensaoFimInput
                    id="suspensaoFimDialog"
                    formControlName="suspensaoFim"
                    dateFormat="dd/mm/yy"
                    dataType="string"
                    placeholder="DD/MM/AAAA"
                    [iconDisplay]="'input'"
                    [showIcon]="true"
                    [appendTo]="'body'"
                    [styleClass]="classeDatePickerSuspensao('suspensaoFim')"
                    [readonlyInput]="!modoEdicao()"
                />
                @if (campoSuspensaoInvalido('suspensaoFim')) {
                    <small class="erro-campo">{{ mensagemErroSuspensao('suspensaoFim') }}</small>
                }
            </div>
            <div class="field md:col-span-2">
                <label for="observacaoSuspensaoDialog" class="font-semibold block mb-2">Observação *</label>
                <input #observacaoSuspensaoInput pInputText id="observacaoSuspensaoDialog" formControlName="observacao" placeholder="Observação" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>
            <div class="field md:col-span-2">
                <label class="font-semibold block mb-2">Divulgar no portal?</label>
                <div class="flex items-center gap-2">
                    <input
                        id="suspensaoDivulgaPortal"
                        type="checkbox"
                        class="w-4 h-4"
                        [checked]="dadosRegistroForm.get('suspensaoDivulgaPortal')?.value === 'S'"
                        (change)="dadosRegistroForm.get('suspensaoDivulgaPortal')?.setValue($any($event.target).checked ? 'S' : 'N')"
                    />
                    <label for="suspensaoDivulgaPortal" class="text-sm">
                        {{ dadosRegistroForm.get('suspensaoDivulgaPortal')?.value === 'S' ? 'Sim' : 'Não' }}
                    </label>
                </div>
            </div>
            <div class="field md:col-span-2">
                <label class="font-semibold block mb-2">Anexo de comprovação PDF *</label>
                <div class="flex flex-wrap items-center gap-2">
                    <input #suspensaoPdfInput type="file" accept="application/pdf" class="hidden" (change)="onSelectSuspensaoPdf($event)" />
                    <p-button label="Selecionar PDF" icon="pi pi-upload" [disabled]="!modoEdicao()" (onClick)="suspensaoPdfInput.click()"></p-button>
                    @if (!arquivoSuspensaoNome) {
                        <span class="text-sm text-color-secondary">Nenhum arquivo selecionado.</span>
                    }
                    @if (arquivoSuspensaoNome) {
                        <span class="text-sm truncate max-w-[240px]">{{ arquivoSuspensaoNome }}</span>
                        <p-button icon="pi pi-times" severity="secondary" [text]="true" [rounded]="true" (onClick)="removerAnexoSuspensao()"></p-button>
                    }
                </div>
                <small class="text-color-secondary block mt-1">PDF até 10 MB.</small>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button type="button" label="Cancelar" styleClass="p-button-text" (onClick)="cancelarDialogSuspensao()"></p-button>
        <p-button type="button" label="Confirmar" (onClick)="confirmarDialogSuspensao()" styleClass="p-button-primary"></p-button>
    </ng-template>
</p-dialog>

<p-dialog appDialogoPadrao="pi pi-ban" descricao="Penalidade publicada contra o médico." header="Censura pública" [(visible)]="mostrarDialogCensuraPublica" [closable]="false" [dismissableMask]="false" [style]="{ width: '600px', maxWidth: '95vw' }">
    <div class="p-fluid" [formGroup]="dadosRegistroForm">
        @if (erroCensurasPublicas()) {
            <div class="text-red-500 text-sm mb-2">{{ erroCensurasPublicas() }}</div>
        }
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="field">
                <label for="censuraPublicaInicioDialog" class="font-semibold block mb-2">Início *</label>
                <p-inputmask
                    id="censuraPublicaInicioDialog"
                    formControlName="censuraPublicaInicio"
                    mask="99/99/9999"
                    placeholder="DD/MM/AAAA"
                    [styleClass]="!modoEdicao() || editandoCensuraPublica() ? 'w-full readonly-input' : 'w-full'"
                    [readonly]="!modoEdicao() || editandoCensuraPublica()"
                />
            </div>
            <div class="field">
                <label for="censuraPublicaFimDialog" class="font-semibold block mb-2">Fim</label>
                <p-inputmask id="censuraPublicaFimDialog" formControlName="censuraPublicaFim" mask="99/99/9999" placeholder="DD/MM/AAAA" [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()" />
            </div>
            <div class="field">
                <label for="censuraPublicaDivulgarPortal" class="font-semibold block mb-2">Divulgar Portal *</label>
                <p-select
                    [appendTo]="'body'"
                    id="censuraPublicaDivulgarPortal"
                    formControlName="censuraPublicaDivulgarPortal"
                    [options]="opcoesSimNao"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione"
                    [styleClass]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'"
                    [readonly]="!modoEdicao()"
                />
            </div>
            @if (!editandoCensuraPublica()) {
                <div class="field md:col-span-2">
                    <label class="font-semibold block mb-2">Anexo PDF *</label>
                    <div class="flex flex-wrap items-center gap-2">
                        <input #censuraPdfInput type="file" accept="application/pdf" class="hidden" (change)="onSelectCensuraPublicaPdf($event)" />
                        <p-button label="Selecionar PDF" icon="pi pi-upload" [disabled]="!modoEdicao() || salvandoCensuraPublica()" (onClick)="censuraPdfInput.click()"></p-button>
                        @if (!arquivoCensuraPublicaNome) {
                            <span class="text-sm text-color-secondary">Nenhum arquivo selecionado.</span>
                        }
                        @if (arquivoCensuraPublicaNome) {
                            <span class="text-sm truncate max-w-[240px]">{{ arquivoCensuraPublicaNome }}</span>
                            <p-button icon="pi pi-times" severity="secondary" [text]="true" [rounded]="true" [disabled]="salvandoCensuraPublica()" (onClick)="removerAnexoCensuraPublica()"></p-button>
                        }
                    </div>
                    <small class="text-color-secondary block mt-1">PDF até 10 MB.</small>
                </div>
            }
            <div class="field md:col-span-2">
                <label for="censuraPublicaObservacaoDialog" class="font-semibold block mb-2">Observações</label>
                <textarea pTextarea id="censuraPublicaObservacaoDialog" formControlName="censuraPublicaObservacao" rows="4" placeholder="Observações" [class]="!modoEdicao() ? 'w-full readonly-input' : 'w-full'" [readonly]="!modoEdicao()"></textarea>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button type="button" label="Cancelar" styleClass="p-button-text" [disabled]="salvandoCensuraPublica()" (onClick)="cancelarDialogCensuraPublica()"></p-button>
        <p-button type="button" label="Confirmar" [loading]="salvandoCensuraPublica()" [disabled]="salvandoCensuraPublica()" (onClick)="salvarCensuraPublica()" styleClass="p-button-primary"></p-button>
    </ng-template>
</p-dialog>
